import { actionTypes as accountActions } from './accountPage.actions';
import { BET_HISTORY_PAGE_LENGTH } from './betHistory.constants';

const initialState = {
    betHistory: [],
    isSettled: false,
    pageLength: BET_HISTORY_PAGE_LENGTH,
    currentPage: 1,
    showBalance: true,
    isExternalBetHistoryError: null,
    externalBetHistoryUrl: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case accountActions.CLEAR_BET_HISTORY:
            return {
                ...state,
                betHistory: [],
                currentPage: 1,
            };
        case accountActions.BET_HISTORY_REQUESTED:
            return {
                ...state,
                betHistory: state.betHistory
                    .concat({
                        loading: true,
                    }),
            };
        case accountActions.BET_HISTORY_RECEIVED:
            return {
                ...state,
                betHistory: action.betHistory,
            };
        case accountActions.SET_BET_HISTORY_ERROR:
            return {
                ...state,
                betHistory: [
                    { errorInfo: action.errorInfo },
                ],
            };
        case accountActions.BET_HISTORY_PAGE_CHANGE:
            return {
                ...state,
                currentPage: action.page,
            };
        case accountActions.TOGGLE_IS_SETTLED:
            return {
                ...state,
                isSettled: !state.isSettled,
                betHistory: [],
                currentPage: 1,
            };
        case accountActions.SET_EXTERNAL_BET_HISTORY_URL:
            return {
                ...state,
                externalBetHistoryUrl: action.externalBetHistoryUrl,
                isExternalBetHistoryError: false,
            };
        case accountActions.SET_EXTERNAL_BET_HISTORY_ERROR:
            return {
                ...state,
                isExternalBetHistoryError: true,
            };
        case accountActions.CLEAR_EXTERNAL_BET_HISTORY_DATA:
            return {
                ...state,
                isExternalBetHistoryError: null,
                externalBetHistoryUrl: null,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/accountPage.reducer.js